import {LRG_IMAGE, MED_IMAGE, SML_IMAGE, XLRG_IMAGE, DPR_1, DPR_2} from '../../utils/constants';
import { getImagePath } from '../../utils/imagePath';

const componentDirectory = 'selling_proposition';

export const smallSellingProposition = getImagePath({width: '600', dpr: DPR_1, componentDirectory, img: '599-selling-proposition-2x.png'});
export const smallSellingProposition2x = getImagePath({width: '600', dpr: DPR_2, componentDirectory, img: '599-selling-proposition-2x.png'});

export const mediumSellingProposition = getImagePath({width: '900', dpr: DPR_1, componentDirectory, img: '899-selling-proposition-2x.png'});
export const mediumSellingProposition2x = getImagePath({width: '900', dpr: DPR_2, componentDirectory, img: '899-selling-proposition-2x.png'});

export const largeSellingProposition = getImagePath({width: '600', dpr: DPR_1, componentDirectory, img: '1159-selling-proposition-2x.png'});
export const largeSellingProposition2x = getImagePath({width: '600', dpr: DPR_2, componentDirectory, img: '1159-selling-proposition-2x.png'});

export const xlargeSellingProposition = getImagePath({width: '700', dpr: DPR_1, componentDirectory, img: '1400-selling-proposition-2x.png'});
export const xlargeSellingProposition2x = getImagePath({width: '700', dpr: DPR_2, componentDirectory, img: '1400-selling-proposition-2x.png'});

export const videoUrl = 'https://cloudinary.fiverrcdn.com/video/upload/vc_auto,q_70/general_assets/logged_out_homepage/assets/campaign.mp4';

export const pictureData = [
    {
        srcSet: `${xlargeSellingProposition} 1x, ${xlargeSellingProposition2x} 2x`,
        media: XLRG_IMAGE
    },
    {
        srcSet: `${largeSellingProposition} 1x, ${largeSellingProposition2x} 2x`,
        media: LRG_IMAGE
    },
    {
        srcSet: `${mediumSellingProposition} 1x, ${mediumSellingProposition2x} 2x`,
        media: MED_IMAGE
    },
    {
        srcSet: `${smallSellingProposition} 1x, ${smallSellingProposition2x} 2x`,
        media: SML_IMAGE
    }
];

export const imgSrc = xlargeSellingProposition;
